/*
 * Copyright © 2021-present Protonbase Inc. All rights reserved.
 * The information contained in this software is confidential and proprietary to Protonbase Inc. and its subsidiaries. No part of this software may be used, copied, reproduced, modified, displayed, performed, executed, published, distributed, conveyed, stored, transmitted, or otherwise exploited in any form or by any means, including but not limited to electronic, mechanical, photocopying, recording, transcribing, without the prior written consent of Protonbase Inc.
 * Any violation of the above terms will constitute an infringement of copyright and will be subjected to legal action.
 */
import React, { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import styles from './index.less'

export function PlatformAnchor(
  props: React.PropsWithChildren<
    {
      id: string
    } & React.HTMLAttributes<HTMLDivElement>
  >,
) {
  const { id, ...rest } = props
  const navigate = useNavigate()
  const { hash } = useLocation()

  const onClick = () => {
    navigate({ hash: id })
    document.querySelector(hash)?.scrollIntoView({ behavior: 'smooth' })
  }

  useEffect(() => {
    if (!hash) {
      return
    }
    const target = document.querySelector(hash)
    setTimeout(() => document.querySelector(hash)?.scrollIntoView({ behavior: 'smooth' }), target ? 0 : 800)
  }, [hash])

  return (
    <span className={styles.container} id={id} {...rest}>
      {props.children}
      <a className={styles.anchor} onClick={onClick}>
        #
      </a>
    </span>
  )
}
